import {
    CREATE_MEMBERSHIP_POOL,
    CREATE_MEMBERSHIP_POOL_FAILURE,
    CREATE_MEMBERSHIP_POOL_SUCCESS,
} from 'store/actions/types';

export const createMembershipPool = (payload) => {
    return {
        type: CREATE_MEMBERSHIP_POOL,
        payload: payload,
    };
};

export const createMembershipPoolFailure = (error) => {
    return {
        type: CREATE_MEMBERSHIP_POOL_FAILURE,
        error: error,
    };
};

export const createMembershipPoolSuccess = (response) => {
    return {
        type: CREATE_MEMBERSHIP_POOL_SUCCESS,
        id: response.id,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/membership-pools/createMembershipPools.js